<template>
  <svg
    :id="name"
    xmlns="http://www.w3.org/2000/svg"
    width="16px"
    height="16px"
    :class="active ? 'white-icon' : 'dark-icon'"
    viewBox="0 0 512 512">
    <g id="Solid">
      <path d="m400 24a24 24 0 0 0 -24 24v272a32 32 0 0 1 -32 32h-174.059l47.03-47.029a24 24 0 0 0 -33.942-33.942l-88 88a24 24 0 0 0 0 33.942l88 88a24 24 0 0 0 33.942-33.942l-47.03-47.029h174.059a80 80 0 0 0 80-80v-272a24 24 0 0 0 -24-24z" />
    </g>
  </svg>
</template>

<script>

export default {
  name: 'CoozzyEnterIcon',
  props: {
    name: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.dark-icon .fill1 {
  fill: #000
}
.white-icon {
  fill: #fff
}
</style>
